import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("ProjectItemSame", {
  title: "Project item SAME",
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
    redirectAfterDelete: {
      title: "Redirection target after Project delete",
      description:
        "Reference where user should be redirected after project delete",
    },
    redirectToProjectConfigurator: {
      title: "Redirection target after click on Project configurator",
      description:
        "Reference where user should be redirected after click on the configurator",
    },
  },
  properties: [
    ...defaultPageProperties,
    "redirectToProjectConfigurator",
    "redirectAfterDelete",
  ],
  propertiesGroups: [
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    showConfiguratorNav: true,
  },
  validations: [
    ...defaultPageValidations,
    ...metadataValidations,
    [
      "redirectToProjectConfigurator",
      (attr) => {
        if (!attr) {
          return {
            message:
              "Reference to project configurator attribute should be set.",
            severity: "warning",
          };
        }
      },
    ],
    [
      "redirectAfterDelete",
      (attr) => {
        if (!attr) {
          return {
            message: "Reference after project delete should be set.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
